export var getIds = id => id ? {
  root: id,
  label: "".concat(id, "__label"),
  avatar: "".concat(id, "__avatar"),
  detail: "".concat(id, "_detail"),
  leftIcon: "".concat(id, "__left-icon"),
  link: "".concat(id, "__link"),
  logo: "".concat(id, "__logo"),
  text: "".concat(id, "__text"),
  description: "".concat(id, "__description"),
  rightIcon: "".concat(id, "__right-icon"),
  rightText: "".concat(id, "__right-text"),
  overlay: "".concat(id, "__overlay")
} : undefined;
//# sourceMappingURL=getIds.js.map